// extracted by mini-css-extract-plugin
module.exports = {"status":"AgentStatus_status__1TLNs","icon":"AgentStatus_icon__1QFry","svg":"AgentStatus_svg__Q4l3i","tooltip":"AgentStatus_tooltip__2RtAc"};